module.exports = __webpack_public_path__ + "static/media/teledent_horizontal.2bf5402b.png";